<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：服务信息
  -->
  <div class="pb50">
    <div class="product-content">
      <!--基本信息-->
      <div class="common-form">报备信息</div>
      <div class="table-wrap">
        <el-row>
          <el-col>
            <div class="pb16">
              <span class="gray9">订单ID：</span>
              {{ detail.report?detail.report.orderId :''}}
            </div>
          </el-col>
          <el-col>
            <div class="pb16">
              <span class="gray9">报备类型：</span>
              <span style="color:red" v-if="detail.report">
                <span v-if="detail.report.type==1">沟通玩到</span>
                <span v-if="detail.report.type==2">不需要物料包</span>
                <span v-if="detail.report.type==3">补车费</span>
                
              </span>

            </div>
          </el-col>
          <el-col>
            <div class="pb16">
              <span class="gray9">图片信息：</span>
              <img v-if="detail.report && detail.report.images" :src="detail.report.images" alt="" width="60px" height="60px">
            </div>
          </el-col>
          <el-col>
            <div class="pb16">
              <span class="gray9">报备时间：</span>
              {{ detail.report? detail.report.createTime:'' }}
            </div>
          </el-col>
          <el-col>
            <div class="pb16">
              <span class="gray9">报备内容：</span>
              <span style="color:red">
                {{ detail.report? detail.report.content:'' }}
              </span>
            </div>
          </el-col>
        </el-row>

      </div>

    </div>

  </div>
</template>

<script>

export default {
 inject: ["detail"],
  data() {
    return {};
  },
  created() {
     this.$forceUpdate()
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.img {
  width: 60px;
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/order/order/part/report.vue